import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteAccountTaskTypeAsync, updateAccountTaskTypeAsync, getAccountTaskTypesByAccountTaskTypeIdAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting } from '../taskType/TaskTypeSlice';
import { Dropdown } from 'react-bootstrap'
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus} from '../../../common/timeLiveFunction';
import { getValueFromResource } from '../../../common/timeLiveFunction';
const itemClass = 'ms-1 ms-lg-0';

const TaskTypeItem = (props: any) => {
    const { TaskTypeList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const { isLoading,sortOrder, sortColumn,pageSize  } = useAppSelector((state) => state.taskType);

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountTaskTypeId: number) => {
        dispatch(getAccountTaskTypesByAccountTaskTypeIdAsync(AccountTaskTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onDeleteClick = (AccountTaskTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountTaskTypeAsync(AccountTaskTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Task type deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountTaskType: any) => {
        const { checked } = e.target;
        const foundIndex = TaskTypeList.findIndex((item: any) => item.AccountTaskTypeId === AccountTaskType.AccountTaskTypeId);
        if (foundIndex !== -1) {
            const foundItem = TaskTypeList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...TaskTypeList.slice(0, foundIndex), updatedItem, ...TaskTypeList.slice(foundIndex + 1)];
            dispatch(updateAccountTaskTypeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Task type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }


    return (
        <>
            
                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                    <thead>
                        <tr className="thHeading align-middle " >
                        <th style={{width:'15%'}}>
                            {/* {t('Active / Inactive')} */}
                            {getValueFromResource('Active / Inactive',dispatch, t)}

                        {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'70%'}}>
                            {/* {t('Task Type')} */}
                            {getValueFromResource('Task Type',dispatch, t)}

                            {sortColumn === 'TaskType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                            {/* {IsEdit &&
                                <th className='w-15'>{t('Active / Inactive')}</th>
                            } */}
                            <th className='w-10 text-center'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {TaskTypeList.length > 0 && TaskTypeList.map((taskTypeDetail: any, i: any) => (
                            <tr key={i}>
                                <td>
                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(taskTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                        {taskTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                    </span>
                                </td>
                                <td className='text-gray-800  text-hover-primary custom-pointer-cursor ' onClick={IsEdit ? () => onEditClick(taskTypeDetail.AccountTaskTypeId) : undefined}>
                                    <span className="   d-block "
                                    >{taskTypeDetail.TaskType}</span>
                                </td>
                                {/* {IsEdit &&
                                    <td className='text-center'>

                                        <div className="form-check form-switch form-check-custom">
                                            <input
                                                type="checkbox"
                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                id="IsDisabled"
                                                checked={taskTypeDetail.IsDisabled === 'Yes' ? true : false}
                                                onChange={(e) => { handleIsDisabledChange(e, taskTypeDetail) }}
                                            />
                                           
                                        </div>

                                    </td>
                                } */}
                                 <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}

                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                {IsEdit &&
                                                    <>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => {
                                                                    dispatch(getAccountTaskTypesByAccountTaskTypeIdAsync(taskTypeDetail.AccountTaskTypeId))
                                                                        .unwrap()
                                                                        .then((originalPromiseResult) => {
                                                                            onopenModal();
                                                                        })
                                                                        .catch((rejectedValueOrSerializedError) => {
                                                                        })
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}

                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </>
                                                }
                                                {IsDelete && IsEdit && (taskTypeDetail.MasterAccountTaskTypeId === null || taskTypeDetail.MasterAccountTaskTypeId === 0) &&
                                                    <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                }
                                                {IsDelete && (taskTypeDetail.MasterAccountTaskTypeId === null || taskTypeDetail.MasterAccountTaskTypeId === 0) &&
                                                    <>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => { onDeleteClick(taskTypeDetail.AccountTaskTypeId) }}>
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {/* {`${t('Delete')}`} */}
                                                                    {getValueFromResource('Delete',dispatch, t)}

                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </>
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {TaskTypeList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}

                                            </p>
                                    </div>
                                }

        </>
    )

}

export default TaskTypeItem
